import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { Link } from 'react-router'
// import { FormattedDate, FormattedTime } from 'react-intl'
// import { ACTIONS } from 'constants/enums'
import { Button } from 'components/misc'
import styles from './actions.styl'

export default class Actions extends Component {
  static propTypes = {
    actions: PropTypes.array.isRequired
  }

  state = {
    limit: 4,
    offset: 4
  }

  handleMapParamsToSummary = item => {
    const summary = item.summary
      .replace('{0}', `<strong>${item.summaryParam0}</strong>`)
      .replace('{1}', `<strong>${item.summaryParam1}</strong>`)
      .replace('{2}', `<strong>${item.summaryParam2}</strong>`)

    return { __html: summary }
  }

  handleDisplayMore = () => {
    this.setState({
      limit: this.state.limit + this.state.offset
    })
  }

  render() {
    const { actions } = this.props
    const { limit } = this.state

    const mappedActions = actions
      .map(item => {
        if (!item.summary || item.summary === 'approved') {
          return null
        }

        return (
          <div key={item.id} className={styles.module}>
            <span className={`ico ico--user ${styles.ico}`} />
            <div
              dangerouslySetInnerHTML={this.handleMapParamsToSummary(item)}
            />
          </div>
        )
      })
      .filter(item => item)

    const actionsToDisplay = mappedActions.filter(
      (item, index) => index < limit
    )

    return (
      <div>
        {actionsToDisplay}
        {mappedActions.length > limit &&
          <div className="text--right">
            <Button tertiary className="link" onClick={this.handleDisplayMore}>
              Show more
            </Button>
          </div>}
        {actions.length === 0 && <span>No actions</span>}
      </div>
    )
  }
}
